export const HorizontalLineSpacer = () => {
  return (
    <div className="forloeb-overview-row-spacer" />
  )
}